import { useCallback } from 'react'

import { Button, Modal } from '@heroui/react'
import { useTranslation } from 'react-i18next'

interface DiscardChangesDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onAccept: () => void;
}

export default function DiscardChangesDialog({
  isOpen,
  onCancel,
  onAccept,
}: DiscardChangesDialogProps) {
  const { t } = useTranslation()

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onAccept()
      }
    },
    [onAccept],
  )

  return (
    <Modal isOpen={isOpen} onOpenChange={handleOpenChange}>
      <Modal.Backdrop variant="blur" className="bg-zinc-950/40" isDismissable>
        <Modal.Container placement="center" size={'lg'}>
          <Modal.Dialog>
            <Modal.CloseTrigger onClick={onAccept} />
            <Modal.Header>
              <Modal.Heading className="font-bold">
                {t('general.discard.title')}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body className="mt-2">
              <p className="text-sm text-zinc-500 dark:text-zinc-400">
                {t('general.discard.description')}
              </p>
            </Modal.Body>
            <Modal.Footer className="flex gap-3 justify-end mt-6">
              <Button
                variant="ghost"
                onClick={onAccept}
              >
                {t('general.discard.keepEditing')}
              </Button>
              <Button
                variant="danger"
                onClick={onCancel}
              >
                {t('general.discard.discard')}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  )
}
